<template>
  <ss-modal
    v-if="isVisible"
    class="md"
    title="Wybór daty spełnienia warunku"
    intro="bounceIn"
    outro="bounceOut">
    <!-- HEADER -->
    <div slot="modal-header">
      Wybór daty spełnienia warunku
      <i class="close" @click="closeModal"></i>
    </div>
    <!-- BODY -->
    <div slot="modal-body">
      <div class="form-group">
        <label>Data spełnienia warunku</label>
        <ss-date
          type="text"
          name="fulfilled_date"
          v-model="fulfilledDate"
          :class="{'is-invalid': lar_errors.has('fulfilled_date')}"
          date-format="YYYY-MM-DD"
          placeholder="Wybierz datę spełnienia"
        />
        <div
          class="invalid-feedback"
          :class="{'d-block': lar_errors.get('fulfilled_date')}"
          v-text="lar_errors.get('fulfilled_date')">
        </div>
      </div>
    </div>
    <!-- FOOTER -->
    <div slot="modal-footer">
      <d-button
        @click.prevent="closeModal"
        theme="danger">
        <i class="material-icons">close</i> Anuluj
      </d-button>
      <d-button
        @click.prevent="confirmFulfilledCondition"
        theme="success"
        class="ml-3">
        <i class="material-icons">check</i> Potwierdź
      </d-button>
    </div>
  </ss-modal>
</template>

<script>
import LarErrors from '@/helpers/Errors';
import SsDate from '@/components/common/SsDate'
import SsModal from '@/components/common/SsModal'

export default {
  name: 'FulfilledConditionModal',
  components: {
    SsDate,
    SsModal
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    condition: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      lar_errors: LarErrors,
      fulfilledDate: ''
    }
  },
  watch: {
    isVisible (newValue) {
      if (newValue && this.condition) {
        this.fulfilledDate = this.condition.checked_date || '';
      }
    }
  },
  methods: {
    closeModal () {
      this.lar_errors.clear('fulfilled_date');
      this.fulfilledDate = '';
      this.$emit('close');
    },
    confirmFulfilledCondition () {
      if (!this.fulfilledDate) {
        this.lar_errors.record({ fulfilled_date: 'Data spełnienia jest wymagana' });
        return;
      }

      // Clear any previous errors
      this.lar_errors.clear('fulfilled_date');

      // Emit the confirmed condition with the selected date
      this.$emit('confirm', {
        ...this.condition,
        checked_date: this.fulfilledDate,
        status: '1'
      });

      this.closeModal();
    }
  }
}
</script>
